import { useSelector } from 'react-redux';

import advanceFlow from '@/utils/flows/advanceFlow';
import getFlowProgress from '@/utils/flows/getFlowProgress';
import formatName from '@/utils/format/formatName';
import { cn } from '@/utils/lib/utils';
import { CheckSquare } from '@/utils/lucide';
import { Square } from '@/utils/lucide';

import { RootState } from '@/redux/store';

const SelectAllRowsButton = ({ onClick, column, selected, table }: { onClick: any; column: any; selected: boolean; table: any }) =>
{
	const filterTriggerFlag = useSelector((state: RootState) => state.cache.flags['advanced-filter-trigger']);
	const customTableBuilderFlag =
		getFlowProgress('custom_table_builder_new_list', 'add_and_apply_filters') && !getFlowProgress('custom_table_builder_new_list', 'select_items'); //useSelector((state: RootState) => state.cache.flags['custom_table_builder_new_list']);

	//Only highlight the button if the user is in the custom table builder flow, the filters have been applied, and the button is not selected.
	const highlight = !filterTriggerFlag && customTableBuilderFlag && !selected;

	return (
		<button
			className={cn('w-full')}
			onClick={e =>
			{
				onClick(e);

				//If part of guided flow, advance to next step
				advanceFlow('custom_table_builder_new_list', 'select_items');
			}}
		>
			<p className='flex flex-row items-center gap-x-2'>
				<span className={highlight ? 'ring-2 ring-maven-primary-500 rounded-md' : ''}>
					{selected ? <CheckSquare className='text-icon' /> : <Square className='text-icon' />}
				</span>
				{formatName(column.columnDef.meta?.displayName ?? column?.columnDef?.accessorKey)}
			</p>
		</button>
	);
};

export default SelectAllRowsButton;
